import styled from 'astroturf/react';

import Button from 'src/components/Button';

const LinkButton = styled(Button)`
  border-bottom: 0 !important;
`;

const SubmitButton = styled(Button)`
  padding: 13px 41px;
  min-width: 0;
`;

const Title = styled('span')`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--ph-heading-three);
`;

export default {
  LinkButton,
  SubmitButton,
  Title,
};
